module.exports = __webpack_public_path__ + "static/img/hs.200203c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/games/games_colorful/hs.svg
// module id = 1E33
// module chunks = 38